export default "__VITE_ASSET__CsStQcLE__"